import navigationEntries from '@/lib/navigationEntries';
import { Button } from '@mantine/core';
import { Link } from '@tanstack/react-router';

export default function Navigation() {
  return (
    <nav>
      <ul
        css={{
          height: '100%',
          listStyle: 'none',
          margin: 0,
          padding: 0,
          display: 'flex',

          a: {
            height: '100%',

            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
          },

          'a[data-status="active"]': {
            backgroundColor: 'var(--mantine-color-primary-filled)',

            '&:hover': {
              backgroundColor: 'var(--mantine-color-primary-filled)',
            },
          },
        }}
      >
        {navigationEntries.map(({ to, icon, label, rightSection }) => (
          <li key={to}>
            <Link to={to} activeOptions={{ includeSearch: false }}>
              <Button variant="transparent" color="inherit" leftSection={icon} rightSection={rightSection}>
                {label}
              </Button>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
